<template>
  <div class="detail-box">
    <h2 class="is-print-hide title-area">
      <div class="main-title advance">
        处方详情
        <span v-if="prescriptionDetail.medicalInsuranceTag !== undefined" class="tag">
          {{ prescriptionDetail.medicalInsuranceTag | mapMedicalInsuranceTag }}
        </span>
      </div>
      <div class="handler-area">
        <el-button
          v-if="prescriptionDetail.canPrescriptionRevocation"
          class="margin-left"
          @click="handleRevocation"
          type="info"
          plain
          size="small"
        >
          撤销处方
        </el-button>
        <el-button
          v-if="dropdownItemShow('删除')"
          class="margin-left"
          @click="delPrescription"
          type="info"
          plain
          size="small"
        >
          删除处方
        </el-button>
        <el-button
          @click="download"
          class="margin-left"
          v-if="dropdownItemShow('下载')"
          v-permission.not="'h,i,j'"
          type="info"
          plain
          size="small"
        >
          下载处方
        </el-button>
        <el-button
          class="margin-left"
          v-if="dropdownItemShow('下载')"
          v-permission.not="'h,i,j'"
          @click="print"
          type="info"
          plain
          size="small"
        >
          打印处方
        </el-button>
        <el-button
          class="margin-left"
          v-if="dropdownItemShow('下载')"
          v-permission.not="'h,i,j'"
          @click="receiptPrint"
          type="info"
          plain
          size="small"
        >
          打印小票
        </el-button>
        <!-- <el-button
          @click="downloadEMR"
          class="margin-left"
          v-if="dropdownItemShow('下载')"
          v-permission.not="'h,i,j'"
          type="info"
          plain
          size="small"
        >
          下载电子病历
        </el-button> -->
      </div>
    </h2>
    <breadcrumb firstName="处方列表"></breadcrumb>
    <div class="main is-print-hide">
      <div class="detail" ref="wrapper">
        <barcode-bar v-if="prescriptionDetail.prescriptionTotalStatus < 3" :barcode-list="barcodeList"></barcode-bar>
        <prescription-desc :prescriptionDetail="prescriptionDetail" @refreshDetail="fetchDetail" />
        <patient-detail :prescriptionDetail="prescriptionDetail" />
        <!-- 处方撤销操作记录 -->
        <div class="revocation-record" v-if="revocationRecordList && revocationRecordList.length > 0">
          <h3>处方撤销操作记录</h3>
          <el-table
            :data="revocationRecordList"
            border
            style="width: 100%"
            header-row-class-name="common-table-header"
            row-class-name="common-table-row"
            class="common-table"
          >
            <el-table-column prop="revocationTime" label="撤销发起时间" min-width="160">
              <template slot-scope="scope">
                {{ formatRevocationTime(scope.row.revocationTime) }}
              </template>
            </el-table-column>
            <el-table-column prop="revocationUserName" label="撤销发起人" min-width="120"></el-table-column>
            <el-table-column prop="reason" label="撤销原因" min-width="200"></el-table-column>
            <el-table-column prop="revocationStatus" label="撤销结果" min-width="150">
              <template slot-scope="scope">
                {{ getRevocationResultText(scope.row.revocationStatus) }}
                <span v-if="scope.row.revocationStatus === 2 && scope.row.revocationFailMsg">
                  ,{{ scope.row.revocationFailMsg }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="advisoryType" v-if="prescriptionDetail.advisoryTypeStr">
          <h3>咨询方式</h3>
          {{ prescriptionDetail.advisoryType | mapAdvisoryType }}
        </div>
        <drug-advice v-if="prescriptionDetail.prescriptionType !== 1" :prescriptionDetail="prescriptionDetail" />
        <chineseDrugAdvice v-else :prescriptionDetail="prescriptionDetail" />
        <prescription-preview
          @download="download"
          v-if="dropdownItemShow('下载')"
          :handlerShow="dropdownItemShow"
          :url="prescriptionDetail.prescriptionImgUrl"
          :is-medical-insurance="prescriptionDetail.isExternal"
          :no-img-show-text="prescriptionDetail.noImgShowText"
          @print="print"
          @receiptPrint="receiptPrint"
          @del="delPrescription"
          @downloadEMR="downloadEMR"
        />
        <prescription-audit :prescriptionDetail="prescriptionDetail" />

        <div v-if="prescriptionDetail.medicalTransferDTO" class="deduction-package">
          <h3>医保流转信息</h3>
          <el-table :data="tableData" border style="width: 600px">
            <el-table-column prop="date" label="日期" width="180">
              <template #default="{ row }">
                {{ row.date | timeFormat }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="500">
              <template #default="{ row }">
                {{ row.status }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 扣费套餐信息 - 完全一致风格 -->
        <div class="deduction-package" v-if="prescriptionDetail.packageDetail">
          <h3>扣费套餐</h3>
          <el-row>
            <el-col :span="24">
              <div class="package-info">
                <div>套餐名称：{{ prescriptionDetail.packageDetail.packageName || '-' }}</div>
                <div>签约网院：{{ prescriptionDetail.packageDetail.hospitalName || '-' }}</div>
                <div>收费模式：{{ prescriptionDetail.packageDetail.feeModel || '-' }}</div>
                <div>合同编号：{{ prescriptionDetail.packageDetail.contractId || '-' }}</div>
              </div>
            </el-col>
          </el-row>
        </div>

        <im-history :imData="prescriptionDetail.chatMessageList"></im-history>
        <pharmacistContactData
          v-if="prescriptionDetail.videoRecordVos && prescriptionDetail.videoRecordVos.length"
          :videoRecordVos="prescriptionDetail.videoRecordVos"
        />
      </div>
    </div>
    <div v-if="prescriptionDetail.submitterUcId == ucUserId" class="footer-btn is-print-hide">
      <contact-store from="1" :prescriptionDetail="prescriptionDetail"></contact-store>
    </div>

    <!-- <div class="footer-btn is-print-hide" @click="contactStore">
      <el-popover
        placement="top-start"
        trigger="hover"
        :content="
          `如需${contactMap[prescriptionDetail.showConnect]}，可以在APP端-【全部处方】中打开本处方，发起视频电话`
        "
      >
        <p class="contact" slot="reference">
          {{ contactMap[prescriptionDetail.showConnect] }}
        </p>
      </el-popover>
    </div> -->
    <!-- 撤销处方对话框 -->
    <revocation-dialog
      :visible.sync="revocationDialogVisible"
      :prescription-id="currentRevocationId"
      @success="handleRevocationSuccess"
      @cancel="handleRevocationCancel"
    ></revocation-dialog>
  </div>
</template>

<script>
import watermark from '@/util/watermark';
import prescriptionDesc from '@/components/prescriptionDesc.vue';
import patientDetail from '@/components/patientDetail.vue';
import drugAdvice from '@/components/drugAdvice.vue';
import chineseDrugAdvice from './components/chineseDrugAdvice.vue';
import prescriptionAudit from '@/components/prescriptionAudit.vue';
import prescriptionPreview from './components/prescriptionPreview.vue';
import imHistory from '@/components/imHistory.vue';
import printImg from '@/components/printPrescriptionImg';
import breadcrumb from '@/components/global/breadcrumb';
import contactStore from '@/components/global/contactStore/contactStore';
import print from '@/components/printImg/index';
import pharmacistContactData from './components/pharmacistContactData';
import { hasPermission, downloadByLink } from '@/util';
import Constant from '@/lib/constant';
import Fetch from '@/api';
import Vue from 'vue';
import { Popover } from 'element-ui';
import { mapState } from 'vuex';
import DownloadModal from './components/ImageDownloadModal';
import printReceipt from '@/components/printReceipt';
import barcodeBar from './components/barcodeBar.vue';
import RevocationDialog from './components/revocationDialog.vue';
import dayjs from 'dayjs';

const { prescriptionHandlerRule, baseRole } = Constant;
Vue.use(Popover);
export default {
  name: 'PrescriptionDetail',
  inject: ['_prescription'],
  components: {
    prescriptionDesc,
    patientDetail,
    drugAdvice,
    prescriptionAudit,
    prescriptionPreview,
    imHistory,
    printImg,
    breadcrumb,
    contactStore,
    pharmacistContactData,
    chineseDrugAdvice,
    barcodeBar,
    RevocationDialog
  },
  data() {
    return {
      prescriptionDetail: {},
      auditable: this.$route.query.auditable,
      contactMap: {
        CLERK: '联系店员',
        PHARMACIST: '联系药师'
      },
      // 撤销处方相关
      revocationDialogVisible: false,
      currentRevocationId: '' // 当前要撤销的处方ID
    };
  },
  mounted() {
    const { userName, companyName } = this.$store.getters;
    watermark.set(`${companyName || ''} ${userName || ''},隐私信息严禁截屏打印`, this.$refs.wrapper);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchDetail();
    });
  },
  beforeRouteLeave(to, from, next) {
    watermark.remove(this.$refs.wrapper);
    next();
  },
  computed: {
    ...mapState('video', ['webRtc', 'isCallReceived']),
    ...mapState('global', ['prescriptionTemplate', 'ucUserId']),
    revocationRecordList() {
      const { revocationDetail } = this.prescriptionDetail;
      if (!revocationDetail) {
        return [];
      }
      // 如果是数组，直接返回
      if (Array.isArray(revocationDetail)) {
        return revocationDetail;
      }
      // 如果是对象，转换为数组
      if (typeof revocationDetail === 'object') {
        return [revocationDetail];
      }
      return [];
    },
    barcodeList() {
      const { prescriptionDetail } = this;
      return [
        {
          label: '处方编号',
          value: prescriptionDetail.id
        },
        {
          label: '医生医保编码',
          value: prescriptionDetail.doctorCode
        },
        {
          label: '互联网医院/机构编码',
          value: prescriptionDetail.hospitalMedicalCode
        },
        {
          label: '药师医保编码',
          value: prescriptionDetail.prePharmacistMedicalCode
        }
      ].filter(o => /^[^\u4e00-\u9fa5]*$/.test(o.value) && o.value);
    },
    tableData() {
      const { toTransferTime, transferTime, transferEndTime, transferStatus, costTime, transferFailMsg, transferDesc } =
        this.prescriptionDetail.medicalTransferDTO;
      return [
        {
          date: toTransferTime,
          status: toTransferTime ? '待流转' : '-'
        },
        {
          date: transferTime,
          status: transferTime ? `流转中${transferDesc ? ',' + transferDesc : ''}` : '-'
        },
        {
          date: transferEndTime,
          status: transferEndTime ? (transferStatus === 3 ? transferFailMsg : `流转成功（累计耗时${costTime}秒）`) : '-'
        }
      ];
    }
  },
  methods: {
    fetchDetail() {
      let id = this.$route.params.id;
      Fetch.prescriptionDetail({ id: id }).then(
        data => {
          // 升序排序
          let { chatMessageList } = data;
          if (chatMessageList instanceof Array) {
            chatMessageList = this.timeSort(chatMessageList);
          }
          data.chatMessageList = chatMessageList;
          this.prescriptionDetail = data;
        },
        () => {
          console.log('出错了');
        }
      );
    },
    // 获取要打印图片
    print() {
      const { id, advisoryType } = this.prescriptionDetail;

      if (this.prescriptionTemplate === 1 && advisoryType !== 8) {
        Fetch.batchPrintImage({ idList: [id], printType: 'ONE_LINE_ONE' }).then(res => {
          if (res.imgUrlList && res.imgUrlList.length > 0) {
            print(res.imgUrlList, () => Fetch.print_prescription([id]), 'pdf');
          }
        });
      } else {
        Fetch.getImgUrlByPrescriptionIdList({ prescriptionIdList: [id], colourType: 1 }).then(res => {
          if (res.urlInfoList && res.urlInfoList.length > 0) {
            const source = res.urlInfoList.map(v => ({ ...v, prescriptionImg: v.prescriptionImgUrl }));
            print(source, () => Fetch.print_prescription([id]));
          }
        });
      }
    },
    receiptPrint() {
      const { id } = this.prescriptionDetail;
      Fetch.getReceiptPrinting({ prescriptionId: id }).then(res => {
        printReceipt(res);
      });
    },
    timeSort(time) {
      time = time.sort(function (a, b) {
        return a.time - b.time;
      });
      return time;
    },
    dropdownItemShow(type) {
      const state = this.prescriptionDetail.prescriptionTotalStatus;
      if (type === 'all') {
        return Object.values(prescriptionHandlerRule).some(
          ({ rule, status }) => hasPermission(rule) && status.includes(state)
        );
      }
      const { rule, status } = prescriptionHandlerRule[type];
      return hasPermission(rule) && status.includes(state);
    },
    delPrescription() {
      const { id } = this.$route.params;
      this._prescription
        .delPrescription(id)
        .then(res => {
          this.$store.commit('prescription/CHANGEifFreshPrescriptionListState', true);
          this.$router.replace('/prescription');
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 下载pdf
    download() {
      const { id } = this.$route.params;
      DownloadModal.show({
        selectCallback: context => {
          const queryDownload = Object.entries(context.downloadFrom)
            .map(val => val.join('='))
            .join('&');
          this._prescription.downLoadOne(id, queryDownload);
          context.showDownload = false;
          this._prescription.batchIds = [];
        }
      });
    },
    // 下载电子病历
    downloadEMR() {
      const { id } = this.$route.params;
      const query = `pid=${id}`;
      const url = `${Util.getApiRoot}/pr/load/emr/file?${query}`;
      downloadByLink(url, id);
    },
    handleRevocation() {
      const { id } = this.$route.params;
      this.currentRevocationId = id;
      this.revocationDialogVisible = true;
    },
    handleRevocationSuccess() {
      this.currentRevocationId = '';
      // 刷新详情页
      this.fetchDetail();
      // 刷新列表页
      this.$store.commit('prescription/CHANGEifFreshPrescriptionListState', true);
    },
    handleRevocationCancel() {
      this.currentRevocationId = '';
    },
    formatRevocationTime(timestamp) {
      if (!timestamp) return '';
      return dayjs(timestamp).format('YYYY-MM-DD HH:mm');
    },
    getRevocationResultText(status) {
      const statusMap = {
        0: '撤销中',
        1: '撤销成功',
        2: '撤销失败'
      };
      return statusMap[status] || '';
    }
  },
  filters: {
    mapAdvisoryType(val) {
      return Constant.advisoryTypes[val];
    },
    timeFormat(t) {
      if (t) {
        return dayjs(t).format('YYYY-MM-DD HH:mm:ss');
      } else {
        return '-';
      }
    },
    mapMedicalInsuranceTag(val) {
      return Constant.medicalInsuranceTag[val] || '-';
    }
  }
};
</script>

<style lang="scss">
.advance {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tag {
  line-height: 1;
  padding: 4px 8px;
  font-size: 14px;
  border-radius: 8px;
  background-color: #1890ff;
  color: #fff;
}

// 扣费套餐样式 - 与prescription-audit保持一致
.deduction-package {
  h3 {
    // 继承默认的h3样式，与prescription-audit一致
    margin: 1em 0 0.5em 0;
    font-size: 1.17em;
    font-weight: bold;
  }

  .el-row {
    margin-bottom: 10px;

    .el-col {
      span {
        font-size: 14px;
        line-height: 1.5;

        .amount {
          color: #f56c6c;
          font-weight: 600;
        }

        .balance {
          color: #67c23a;
          font-weight: 600;
        }
      }
    }
  }
}

// 响应式处理
@media (max-width: 768px) {
  .deduction-package {
    .package-info {
      flex-direction: column;
      gap: 8px;

      .info-item {
        min-width: auto;
      }
    }
  }
}

.main {
  padding-bottom: 20px;
}

.deduction-package-simple {
  margin: 12px 0;
  padding: 12px;
  background: #f0f9ff;
  border-radius: 4px;
  border-left: 3px solid #1890ff;

  h4 {
    margin: 0 0 8px 0;
    font-size: 14px;
    color: #333;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: #666;

    .amount {
      color: #f56c6c;
      font-weight: 600;
    }

    .balance {
      color: #67c23a;
      font-weight: 600;
    }
  }
}

.package-info {
  display: flex;
  flex-direction: column;

  gap: 20px;
  div {
    line-height: 1.4;
    font-size: 14px;
  }
}

.detail-box {
  .title-area {
    position: relative;

    .handler-area {
      position: absolute;
      top: 0;
      right: 0;

      button {
        width: 132px;
        height: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 3px;
        border: 1px solid rgba(242, 242, 242, 1);
        font-size: 12px;
        color: rgba(112, 112, 112, 1);
      }
    }
  }
}

.detail {
  position: relative;
  background: #fff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  min-height: 618px;
  padding: 16px 16px 20px;
  margin: 0px 0 48px;

  h3 {
    height: auto;
    padding: 48px 0 12px;
    font-size: 18px;
    font-family: MicrosoftYaHeiUI;
    font-weight: bold;
    color: rgba(36, 36, 36, 1);
  }

  label {
    display: inline-block;
    color: #242424;
    font-size: 14px;
    margin: 0;
  }

  span {
    font-size: 14px;
    color: #707070;
  }

  .el-row {
    min-height: 40px;
    line-height: 40px;
    // margin-bottom: 10px;
    width: 100%;
    display: inline-block;
  }

  .prescription-img {
    clear: both;
    width: 400px;

    img {
      width: 100%;
    }
  }

  .split-line {
    margin: 20px 0;
  }

  .strong-color {
    color: #f56b56;
  }
}
.revocation-record {
  margin: 20px 0;
  h3 {
    height: auto;
    padding: 48px 0 12px;
    font-size: 18px;
    font-family: MicrosoftYaHeiUI;
    font-weight: bold;
    color: rgba(36, 36, 36, 1);
  }
}

.footer-btn {
  position: fixed;
  bottom: 0;
  left: 200px;
  right: 0;
  height: 48px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
  z-index: 999;

  .contact {
    display: flex;
    align-items: center;

    &::before {
      content: '';
      width: 20px;
      height: 20px;
      display: block;
      background: url('../../assets/img/user_header.png') no-repeat;
      background-size: cover;
      margin-right: 5px;
    }
  }
}
</style>
